var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repairService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var PhoneNumberService = /** @class */ (function () {
    function PhoneNumberService() {
    }
    PhoneNumberService.prototype.searchPhoneNumber = function (model, loading) {
        return this.netService.send({
            server: repairService.phoneNumberController.searchPhoneNumber,
            data: {
                phoneNumber: model.phoneNumber
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], PhoneNumberService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], PhoneNumberService.prototype, "searchPhoneNumber", null);
    return PhoneNumberService;
}());
export { PhoneNumberService };
